export default "__VITE_ASSET__GDcXB5bc__"